import React, {useState} from "react";
import image_not_available from "../../../../resources/images/app/ui/image-not-available.png";
import {Modal, ModalBody } from "reactstrap";

export default function OfferItemImg({imgFileName, className = "screen cont", isMobile}) {

    const [isOpen, setIsOpen] = useState(false);
    const [isImgNotFound, setIsImgNotFound] = useState(false);

    const handleImgNotFound = (e) => {
        e.target.src=image_not_available;
        setIsImgNotFound(true);
    };

    const getImg = () => {
        return imgFileName ? (process.env.REACT_APP_OFFER_PICTURE_URL + imgFileName) : image_not_available;
    };

    return (
        <>
            <div className="single-offer-preview" onClick={() => !isImgNotFound && setIsOpen(!isOpen)}>
                <img className={className} src={getImg()} alt="" onError={handleImgNotFound}/>
            </div>

            <Modal centered size={isMobile ? 'sm' : 'md'} isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} >
                <ModalBody>
                    <img className="" src={getImg()} style={{maxHeight: (isMobile ? '80vh' : '90vh'), display: 'block', margin: 'auto'}}
                         onClick={() => setIsOpen(!isOpen)}/>
                </ModalBody>

            </Modal>
        </>
    )
}
